import {RadioGroup, FormControl, Radio, ActionList, CheckboxGroup, Checkbox} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import {useState} from 'react'
import {LABELS} from '../../../constants/labels'
import {MESSAGES} from '../../../constants/messages'

type NotificationSettingsDialogProps = {
  title: string
  onClose: () => void
  onSave: () => void
  returnFocusRef: React.RefObject<HTMLElement>
}

export const NotificationSettingsDialog = ({
  onClose,
  title,
  onSave,
  returnFocusRef,
}: NotificationSettingsDialogProps) => {
  const [showCustomMenu, setShowCustomMenu] = useState(false)

  return (
    <Dialog
      aria-label={LABELS.notifications.notificationsSettings}
      title={title}
      onClose={onClose}
      width="large"
      returnFocusRef={returnFocusRef}
      footerButtons={[
        {content: 'Cancel', onClick: onClose, buttonType: 'normal'},
        {content: 'Save', onClick: onSave, buttonType: 'primary'},
      ]}
    >
      <RadioGroup name="notificationSettingsGroup" onChange={() => {}}>
        <RadioGroup.Label visuallyHidden>{LABELS.notifications.notificationsSettings}</RadioGroup.Label>
        <FormControl>
          <Radio
            value={LABELS.notifications.notSubscribedOption}
            name="subscriptionOption"
            onChange={() => setShowCustomMenu(false)}
          />
          <FormControl.Label>{LABELS.notifications.notSubscribedOption}</FormControl.Label>
          <FormControl.Caption>{MESSAGES.notSubscribedDescription}</FormControl.Caption>
        </FormControl>
        <ActionList.Divider />
        <FormControl>
          <Radio
            value={LABELS.notifications.subscribedOption}
            name="subscriptionOption"
            onChange={() => setShowCustomMenu(false)}
          />
          <FormControl.Label>{LABELS.notifications.subscribedOption}</FormControl.Label>
          <FormControl.Caption>{MESSAGES.subscribedDescription}</FormControl.Caption>
        </FormControl>
        <ActionList.Divider />
        <FormControl>
          <Radio
            value={LABELS.notifications.customOption}
            name="subscriptionOption"
            onChange={() => setShowCustomMenu(true)}
          />
          <FormControl.Label>{LABELS.notifications.customOption}</FormControl.Label>
          <FormControl.Caption>{MESSAGES.customDescription}</FormControl.Caption>
        </FormControl>
        {showCustomMenu && (
          <CheckboxGroup sx={{ml: 4, mt: 2}}>
            <CheckboxGroup.Label visuallyHidden>{LABELS.notifications.customOptions}</CheckboxGroup.Label>
            <FormControl>
              <Checkbox value="one" />
              <FormControl.Label>{LABELS.notifications.closed}</FormControl.Label>
              <FormControl.Caption>{MESSAGES.subscribedToClosedDescription}</FormControl.Caption>
            </FormControl>
            <FormControl>
              <Checkbox value="two" />
              <FormControl.Label>{LABELS.notifications.reopened}</FormControl.Label>
              <FormControl.Caption>{MESSAGES.subscribedToReopenedDescription}</FormControl.Caption>
            </FormControl>
          </CheckboxGroup>
        )}
      </RadioGroup>
    </Dialog>
  )
}

try{ NotificationSettingsDialog.displayName ||= 'NotificationSettingsDialog' } catch {}